<template>
    <v-dialog v-model="dialog" persistent max-width="600px">


        <v-card>
            <v-card-title>
                <span class="headline">Contactez nous</span>
            </v-card-title>
            <v-card-text>
                <v-form @submit="onSubmit" ref="form" lazy-validation>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                                label="Nom et prénom, société *"
                                hint="Votre nom, prénom et/ou raison sociale"
                                persistent-hint
                                required
                                v-model="name"
                                :rules="nameRules"
                                name="name"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                                label="E-mail *" required
                                hint="Votre adresse e-mail valide"
                                :rules="emailRules"
                                v-model="email"
                                name="email">

                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea
                                v-model="message"
                                auto-grow
                                box
                                color="blue"
                                label="Votre message"
                                rows="10"
                                :rules="messageRules"
                                name="message"
                        ></v-textarea>
                    </v-flex>
                </v-form>
                <v-progress-linear :indeterminate="true" v-if="isSending"></v-progress-linear>
                <small>* champs obligatoires</small>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1 white--text text--lighten" @click.native="dialog = false">
                    <v-icon class="white--text text--lighten">close</v-icon>
                    Fermer
                </v-btn>
                <v-btn color="blue darken-1 white--text text--lighten" @click.native="onSubmit">
                    <v-icon class="white--text text--lighten">send</v-icon>
                    Envoyer
                </v-btn>
            </v-card-actions>
            <v-snackbar
                    v-model="snackbar"
                    absolute
                    auto-height
                    bottom
                    :timeout=snackBarTimeOut
                    :color=snackBarColor
            ><span v-html="snackbarText"></span>
                <v-btn
                        color="white"
                        flat
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </v-snackbar>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "ContactForm",
        data: () => ({
            isSending: false,
            valid: false,
            snackbar: false,
            snackbarText: 'Message envoyé',
            snackBarColor: 'success',
            snackBarTimeOut: 10000,
            name: '',
            nameRules: [
                v => !!v || 'Nom requis',
                v => v.length >= 5 || 'Le champs nom doit avoir au moins 5 caractères'
            ],
            email: '',
            emailRules: [
                v => !!v || 'E-mail requis',
                v => /.+@.+/.test(v) || 'L\'adresse email doit être valide'
            ],
            message: "",
            messageRules: [
                v => !!v || 'Message requis',
            ]
        }),
        methods: {
            onSubmit() {
                console.log("On submit")

                if (this.$refs.form.validate()) {
                    this.isSending = true
                    console.log("Form valide")
                    const params = new URLSearchParams()
                    params.append('name', this.name)
                    params.append('email', this.email)
                    params.append('message', this.message)
                    axios.post(`https://jinic-media.com/mail.php`, params)
                        .then(response => {
                            // JSON responses are automatically parsed.
                            this.posts = response.data
                            console.log(this.posts)
                            this.isSending = false
                            if (this.posts != 'OK') {
                                this.snackbar = true
                                this.snackBarColor = 'error'
                                this.snackbarText = 'Votre message n\'a pas réussi à être transmis, vous pouvez envoyer un mail à <a href=\'mailto:contact@bomba-nygma.com\'>contact@bomba-nygma.com</a>'
                            } else {
                                this.isSending=false
                                this.dialog=false
                            }
                        })
                        .catch(e => {
                            this.isSending = false
                            this.snackbar = true
                            this.snackBarColor = 'error'
                            this.snackbarText = 'Votre message n\'a pas réussi à être transmis, vous pouvez envoyer un mail à <a href=\'mailto:contact@bomba-nygma.com\'>contact@bomba-nygma.com</a>'
                            this.errors.push(e)
                        })
                } else {
                    this.snackbar = true
                    this.snackBarColor = 'error'
                    this.snackbarText = 'Vérifiez votre formulaire avant envoi'
                }
            }
        },
        computed:{
            dialog: {
                get () {
                    return this.$store.state.dialogContact
                },
                set (value) {
                    this.$store.commit('showContact', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>